import React from "react";
import Alert from "@material-ui/lab/Alert";
import { AlertSeverity}  from "../services/types";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles, withStyles} from "@material-ui/core/styles";


interface AlertProps {
  message?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
  severity?: AlertSeverity;
}

interface SnackbarProps {
  children?: React.ReactElement<any, any>;
  message?: string;
  open: boolean;
  setOpen: (open: boolean) => void;
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#9D7E47",
  },
}));

const StyledAlert = withStyles({
  filledInfo: {
    backgroundColor: "#8d7140",
  }
})(Alert);

const SimpleSnackbar = ({ message, open, setOpen, children }: SnackbarProps) => {
  const classes = useStyles();

  const handleClose = (
    event: React.SyntheticEvent | React.MouseEvent,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
      message={message}
      ContentProps={{ classes }}
      action={
        <IconButton
          size="small"
          aria-label="close"
          color="inherit"
          onClick={handleClose}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      }
    >
      {children}
    </Snackbar>
  );
};

export const AlertSnackbar = ({ message, open, setOpen, severity = "info" }: AlertProps) => (
  <SimpleSnackbar open={open} setOpen={setOpen}>
    <StyledAlert severity={severity} variant="filled" onClose={() => setOpen(false)}>
      {message}
    </StyledAlert>
  </SimpleSnackbar>
);

export default SimpleSnackbar;
